"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocaleProvider = void 0;
/* eslint-disable react/display-name */
const React = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const locale_context_1 = require("./locale-context");
const locale_hook_1 = require("./locale-hook");
function LocaleProvider({ children, ...props }) {
    const { context } = (0, locale_hook_1.useLocale)(props);
    return (React.createElement(react_intl_1.IntlProvider, { locale: context.locale.intlLocale, defaultLocale: "cs", messages: context.messages, defaultRichTextElements: {
            b: (chunks) => React.createElement("b", null, chunks),
            br: () => React.createElement("br", null),
            p: (chunks) => React.createElement("p", null, chunks),
        } },
        React.createElement(locale_context_1.LocaleContext.Provider, { value: context }, children)));
}
exports.LocaleProvider = LocaleProvider;
//# sourceMappingURL=locale-provider.js.map